import College, {getCollege} from "../../../auxiliary/GetCollege";
import card from "./card.module.css";
import { useData } from "../../dentistContext/DentistConferenceContext";
import { updateItem, deleteItem, getAllItems } from "../../../auxiliary/AxiosAPI/AxiosAPI";
import { useMutation, useQueryClient } from "react-query";

export const DentistCard = ({element}) => {
  const queryClient = useQueryClient();


  const deleteElement = useMutation({
    mutationFn: deleteItem,
    onSuccess:() => queryClient.invalidateQueries(getAllItems)
  })

  const updateElement = useMutation({
    mutationFn: updateItem,
    onSuccess:() => queryClient.invalidateQueries(getAllItems)
  })


 const { setActiveElement} = useData()
  return (
    <div className={card.card} key={element.name+element.id}>
      <div className={card.cardcontents}>
        <h3 style={{fontFamily:'var(--English)'}}>{element.number}</h3>
        <h2 className={card.h2}>{element.fullname}</h2>
        <College college={element.college} />
        {element.email && (
          <h3>
            البريد الألكتروني: <span className={card.email}>{element.email}</span>
          </h3>
        )}
        {element.phone && <h3 > رقم الهاتف: {element.phone}</h3>}
      </div>
      <div className={card.attendenceWrapper}>
        <h3 className={card.attendenceTitle}>الحضور</h3>
        <div className={card.days}>
          <button
            className={card.f1btn}
            style={{
              backgroundColor: element.date1 && "green",
            }}
            onClick={() => {
              element.date1 = !element.date1;
              updateElement.mutate(element);
            }}
          >
            السبت
          </button>
          <button
            className={card.f2btn}
            style={{
              backgroundColor: element.date2 && "green",
            }}
            onClick={() => {
              element.date2 = !element.date2;
              updateElement.mutate(element);
            }}
          >
            الأحد
          </button>
          <button
            className={card.f1btn}
            style={{
              backgroundColor: element.date3 && "green",
            }}
            onClick={() => {
              element.date3 = !element.date3;
              updateElement.mutate(element);
            }}
          >
            الإثنين
          </button>
          <button
            className={card.f2btn}
            style={{
              backgroundColor: element.date4 && "green",
            }}
            onClick={() => {
              element.date4 = !element.date4;
              updateElement.mutate(element);
            }}
          >
            الثلاثاء
          </button>
          <button
            className={card.f1btn}
            style={{
              backgroundColor: element.date5 && "green",
            }}
            onClick={() => {
              element.date5 = !element.date5;
              updateElement.mutate(element);
            }}
          >
            الأربعاء
          </button>
          <button
            className={card.f2btn}
            style={{
              backgroundColor: element.date6 && "green",
            }}
            onClick={() => {
              element.date6 = !element.date6;
              updateElement.mutate(element);
            }}
          >
            الخميس
          </button>
        </div>
      </div>
      <div className={card.controlwrapper}>
        <button
          className={card.cwbtn}
          onClick={() => {
            setActiveElement({
              id:element.id,
              number:element.number,
              fullname:element.fullname,
              email:element.email?element.email:"admin@wpu.sy",
              college:element.college?element.college:"1",
              phone:element.phone?element.phone:""
            });
          }}
        >
          تعديل
        </button>
        <button
          className={card.cwbtn}
          onClick={() => {
            deleteElement.mutate(element);
          }}
        >
          حذف
        </button>
      </div>
    </div>
  );
};
